import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { PhoenixLinkedService } from 'app/model/linkedservice/phoenix.linkedservice';
import { Metamodel } from 'app/model/base/model';
import { PhoenixObjectDataset } from 'app/model/dataset/phoenix.dataset';
import { format } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const phoenixObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(PhoenixObjectDataset).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Phoenix_DisplayText),
    supportLinkedServiceTypes: [Metamodel.modelFor(PhoenixLinkedService).name],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-phoenix'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    splitTablePath: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['Database']
};
